import { conversationTokenFor, loadSession } from './session';
import type { ChatEventName } from './types';

export const CHAT_EVENTS_ENDPOINT = '/api/poc-guide-chat/events';

type DataLayerWindow = Window & { dataLayer?: unknown[] };

function pushToDataLayer(name: ChatEventName, payload: Record<string, unknown>): void {
  const w = window as DataLayerWindow;
  if (!w.dataLayer) w.dataLayer = [];
  try {
    w.dataLayer.push({ event: 'guide_chat', chat_event: name, ...payload });
  } catch {
    // GTM can throw from push(); analytics must never break the chat.
  }
}

function postToBackend(conversationId: string, conversationToken: string, name: ChatEventName, payload: Record<string, unknown>): void {
  if (typeof fetch !== 'function') return;
  try {
    fetch(CHAT_EVENTS_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ conversationId, conversationToken, name, payload }),
      keepalive: true,
    }).catch(() => undefined);
  } catch {
    // Backend unreachable: the dataLayer copy is enough.
  }
}

// Fire-and-forget on purpose: callers never await analytics and never see an error.
export function trackChatEvent(name: ChatEventName, payload: Record<string, unknown> = {}): void {
  if (typeof window === 'undefined') return;
  try {
    const { conversationId: payloadId, ...rest } = payload;
    const conversationId =
      typeof payloadId === 'string' && payloadId ? payloadId : loadSession().conversationId;
    pushToDataLayer(name, conversationId ? { conversation_id: conversationId, ...rest } : rest);
    // The backend journals events only for a conversation it signed.
    const conversationToken = conversationTokenFor(conversationId);
    if (conversationId && conversationToken) postToBackend(conversationId, conversationToken, name, rest);
  } catch {
    // Nothing above may surface to the UI.
  }
}
